import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Table } from '..';
import { REPROCESS_HEADERS } from '../../constants/table-headers';
import ActivityIndicator from '../ActivityIndicator';
import Pagination from '../atoms/pagination';
import './styles.scss';
import useGetDeliveries, {
  GetDeliveriesResponse,
} from '../../hooks/deliveries/useGetDeliveries';
import { Col, Row } from 'react-bootstrap';
import { CartStatus } from '../../types/drawer.types';
import { Cart } from '../../store/ducks/freight/types';
import Historic from '../Freight/components/delivery-history';
import Modals from '../Modal';
import useGetCarts, { GetCartsReponse } from '../../hooks/carts/useGetCarts';
import usePatchCartStatus from '../../hooks/carts/usePatchCartStatus';
import BoxWrapper from '../atoms/boxWrapper';

const TableReprocessing: React.FC = () => {
  const history = useHistory();
  const [selectedDelivery, setSelectedDelivery] = useState<string>('');
  const [showHistory, setShowHistory] = useState<boolean>(false);
  const [isModal, setIsModal] = useState<boolean>(false);
  const { register } = usePatchCartStatus();
  const [currentPage, setCurrentPage] = useState(1);
  const [deliveries, setDeliveries] = useState<GetDeliveriesResponse>({
    rows: [],
    totalRecords: 0,
    page: 1,
  });
  const { execute, loading } = useGetDeliveries();
  const [carts, setCarts] = useState<GetCartsReponse>({
    rows: [],
    totalRecords: 0,
    page: 1,
  });
  const { execute: getCarts } = useGetCarts();
  const [callback, setCallback] = useState<{
    message: string;
    callback: () => void;
  }>({ message: '', callback: () => null });

  const onCartPatched = async (cartId: string, cartStatus: CartStatus) => {
    const cart = await register({
      status: cartStatus,
      cartId: cartId,
    });
    setCarts(prevCarts => {
      const newCarts = prevCarts.rows.map((oldCart: Cart) => {
        if (cart?.cartId === oldCart.cartId) {
          return {
            ...cart,
          };
        }
        return oldCart;
      });
      return {
        ...prevCarts,
        rows: newCarts.filter(
          (el: Cart) => el.cartStatus === CartStatus.RETURNED,
        ),
      };
    });
  };

  const handleCheck = async (cartId: string) => {
    setCallback({
      callback: () => onCartPatched(cartId, CartStatus.WAITING_FREIGHT),
      message: 'Deseja enviar para reentrega?',
    });
    setIsModal(true);
  };

  const handleCancel = async (cartId: string) => {
    setCallback({
      callback: () => onCartPatched(cartId, CartStatus.CANCELLED),
      message: 'Deseja confirmar a devolução?',
    });
    setIsModal(true);
  };

  const onViewHistoric = (cartId: string) => {
    setSelectedDelivery(cartId);
    setShowHistory(true);
  };

  const onViewFreight = (cartId: string) => {
    const cart = carts.rows.find((c: Cart) => c.cartId === cartId);
    const deliveryId = cart?.deliveries?.[0]?.deliveryId;
    if (deliveryId) {
      history.push(`/home/shippings/view/delivery/${deliveryId}`);
    }
  };

  useEffect(() => {
    const loadDeliveries = async () => {
      const deliveries = await execute({
        page: currentPage,
        cartStatus: CartStatus.RETURNED,
      });
      const carts = await getCarts({
        page: currentPage,
        cartStatus: CartStatus.RETURNED,
      });
      if (!deliveries) {
        return;
      }
      setDeliveries(deliveries);
      if (!carts) {
        return;
      }
      setCarts(carts);
    };
    loadDeliveries();
  }, [currentPage]);

  if (loading) {
    return <ActivityIndicator />;
  }

  return (
    <BoxWrapper>
      <div>
        <Modals
          outlined
          onHide={() => setIsModal(false)}
          show={isModal}
          onConfirmClick={callback.callback}
          message={callback.message}
        />
        <Row>
          <Col lg="12">
            <div className="separator" />
            <Table
              columns={REPROCESS_HEADERS}
              data={carts.rows.map(el => ({
                cartId: el.cartId,
                corporateName: el.deliveries[0].corporateName,
                nf: el.receipt.nf,
                address: el.deliveries[0].address,
                cep: el.deliveries[0].cep,
                status: el.cartStatus,
                receiptStatus: el.receipt.status,
              }))}
              onCheck={(id: string) => handleCheck(id)}
              onCancel={handleCancel}
              onViewClick={onViewFreight}
              onViewHistoric={onViewHistoric}
              notShowInput={true}
            />
            <Pagination
              totalRecords={deliveries.totalRecords}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              rowsPerPage={20}
            />{' '}
          </Col>
        </Row>
      </div>
      <Historic
        setShowHistory={setShowHistory}
        isOpen={showHistory}
        cartId={selectedDelivery}
      />
    </BoxWrapper>
  );
};

export default TableReprocessing;
